<template>
  <Question
    v-if="currentQuestion"
    :subtitle="$t('kyc.titles.goal')"
    :title="currentQuestion.title"
    :next-button-theme="nextButtonTheme"
    :back-route="backRoute"
    :progress-ratio="progressRatio"
    @next="next"
  >
    <BaseSection>
      <Choice
        :value="answer"
        :question="currentQuestion"
        class="mb-4"
        @input="changeChoice"
      />
    </BaseSection>
  </Question>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { find } from 'lodash';
import { SET_GOAL_ANSWER } from '../../store/mutation-types';
import Question from './Question.vue';
import Choice from './Choice.vue';
import BaseSection from '../../components/BaseSection.vue';
import kyc from '../../mixins/kyc';

export default {
  name: 'GoalQuestions',
  components: {
    Question,
    Choice,
    BaseSection,
  },
  mixins: [kyc],
  computed: {
    ...mapState('kyc', ['goalQuestions']),
    currentQuestion() {
      const { id } = this.$route.params;
      let lastId;
      if (id === 'last' && this.goalQuestions.length) {
        lastId = this.goalQuestions[this.goalQuestions.length - 1].id;
        this.$router.replace(`/kyc/goal/${lastId}`);
      }
      return find(this.goalQuestions, { id: parseInt((lastId || id), 10) });
    },
    progressRatio() {
      const position = (this.goalQuestions.indexOf(this.currentQuestion) + 1);
      const total = (this.goalQuestions.length + 1);
      const steps = 4;
      const offset = 3 / 4;
      return offset + ((position / total) / steps);
    },
    nextButtonTheme() {
      const answer = this.getGoalAnswer(this.currentQuestion.id);
      if (answer) {
        if (this.currentQuestion.top3) {
          if (!(answer.answer && answer.answer[0] && answer.answer[1] && answer.answer[2])) {
            return 'disabled';
          }
        }
        return 'primary';
      }
      return 'disabled';
    },
    answer() {
      const result = this.getGoalAnswer(this.currentQuestion.id);
      if (result) {
        return result.answer;
      }
      return null;
    },
    index() {
      return this.goalQuestions.indexOf(this.currentQuestion);
    },
    backRoute() {
      if (this.index > 0) {
        return `/kyc/goal/${this.goalQuestions[this.index - 1].id}`;
      }
      return '/kyc/knowledge/last';
    },
    ...mapGetters('kyc', ['getGoalAnswer']),
  },
  created() {
    this.fetchGoalQuestions();
  },
  methods: {
    ...mapActions('kyc', ['updateGoalQuestion']),
    next() {
      this.update();
      const index = this.goalQuestions.indexOf(this.currentQuestion);
      if (index < this.goalQuestions.length - 1) {
        const nextQuestion = this.goalQuestions[index + 1];
        this.$router.push(nextQuestion.id.toString());
      } else {
        this.$router.push('/kyc/attachments');
      }
    },
    ...mapActions('kyc', ['fetchGoalQuestions']),
    changeChoice(value) {
      this.$store.commit(`kyc/${SET_GOAL_ANSWER}`, {
        currentQuestionId: this.currentQuestion.id,
        choice: value,
      });
    },
  },
};
</script>
